import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';

const initialState = {
  loading: false,
  sales: [],
  error: '',
  params: {
    time: 'subMonth',
  },
};

export const fetchOrderSales = createAsyncThunk(
  'statistics/fetchOrderSales',
  (params = {}) => {
    return statisticService
      .ordersCount({ ...initialState.params, ...params })
      .then((res) => res);
  }
);
const orderSalesSlice = createSlice({
  name: 'orderSales',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOrderSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrderSales.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      const data = payload?.data?.data ?? payload?.data ?? payload;
      state.sales = Array.isArray(data) ? data : [];
      state.error = '';
    });
    builder.addCase(fetchOrderSales.rejected, (state, action) => {
      state.loading = false;
      state.sales = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterOrderSales(state, action) {
      const { payload } = action;
      state.params = payload;
    },
  },
});
export const { filterOrderSales } = orderSalesSlice.actions;
export default orderSalesSlice.reducer;
